import Request from 'utilities/Request';
import {stringify} from 'querystring';
import {ROLE_IDS} from 'app/Roles';

export const inviteUser = (displayName, email) =>
  Request.post(`/api/content/v3/users?sendNotification=true`, {
    detail: {email},
    displayName,
    roleId: ROLE_IDS.SOCIAL,
  });

export const resendInvite = email =>
  Request.post(`/api/content/v3/users/invite/resend?${stringify({email})}`);
